export const LUMENREPORT_REQUEST = "LUMENREPORT_REQUEST";
export const LUMENREPORT_RECEIVE = "LUMENREPORT_RECEIVE";
export const LUMENREPORT_FAILURE = "LUMENREPORT_FAILURE";
export const RESET_LUMENREPORT = "RESET_LUMENREPORT";
